import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          this is  {process.env.REACT_APP_ID}
        </p>
        <p>
          this is  {process.env.NODE_ENV}
        </p>
      </header>
    </div>
  );
}

export default App;
